// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import './styles.scss'
import { hot } from 'react-hot-loader'
import { ProgressSteps } from 'components/progressSteps/component'
import { Route, Switch, withRouter } from 'react-router-dom'
import Masthead from '@ta-interaktiv/react-masthead'
import type { VotePreference } from 'components/questionnaire'
import { Questionnaire } from 'components/questionnaire'
import { Article } from 'components/article'
import { MunicipalitySelection } from 'components/municipalitySelection'
import Scrollchor from 'react-scrollchor'
import { Footer } from 'components/footer'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { ScrollToTopOnMount } from 'components/scrollToTop'
import { Methodology } from 'components/methodology'

const ARTICLE_ID = '27103598'

type Props = {
  match: any,
  location: any,
  history: any
}
type State = {
  municipalityId: number,
  votePreference: VotePreference,
  isLoading: boolean,
  publicationDate: number
}

class AppComponent extends React.Component<Props, State> {
  state: State = {
    isLoading: false,
    votePreference: { velo: null, fairFood: null, ernaehrung: null },
    municipalityId: 0,
    publicationDate: 1
  }

  handleMunicipalitySelection = (municipalityId: number) => {
    this.setState({ municipalityId, isLoading: true })

    setTimeout(() => {
      this.props.history.push('/abstimmungsfragen')
      this.setState({ isLoading: false })
    }, 300)
  }

  handleVotePreference = (votePreference: VotePreference) => {
    this.setState({ votePreference, isLoading: true })

    setTimeout(() => {
      this.props.history.push('/artikel/fuer/' + this.state.municipalityId)
      this.setState({ isLoading: false })
    }, 300)
  }

  setLoading = () => {
    this.setState({ isLoading: true })
  }

  unsetLoading = () => {
    this.setState({ isLoading: false })
  }

  componentDidMount () {
    const domain = parseHostname().publicationDomain
    window
      .fetch(`https://m.${domain}/api/articles/${ARTICLE_ID}`)
      .then(response => response.json())
      .then(data => {
        this.setState({ publicationDate: data.article.first_published_at })
      })
      .catch(error => {
        console.warn(error)
      })
  }

  render () {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />

        <header className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header'>
              Haben Sie wie Ihre Gemeinde abgestimmt?
            </h1>

            <h2 className='ui header'>
              <div className='small sub header'>
                Unser Roboter <em>Tobi</em> wandelt Abstimmungsdaten in Texte
                um. Sehen Sie, wie Ihr Dorf oder Ihre Stadt sich an der Urne
                verhalten hat. Wie <em>Tobi</em> 4500 Texte innert Sekunden
                schreiben kann,{' '}
                <Scrollchor to='#methodik'>lesen Sie hier</Scrollchor>.
              </div>
            </h2>
          </div>
        </header>
        <ProgressSteps />
        <main
          className={`ui orange vertical infographic segment ${
            this.state.isLoading ? 'loading' : ''
          }`}
          id='main-content'
        >
          <div className='ui container'>
            <Switch>
              <Route
                exact
                path='/'
                render={props => (
                  <MunicipalitySelection
                    {...props}
                    municipalitySelectionHandler={
                      this.handleMunicipalitySelection
                    }
                  />
                )}
              />
              <Route
                path={'/gemeindeauswahl'}
                render={props => (
                  <React.Fragment>
                    <ScrollToTopOnMount />
                    <MunicipalitySelection
                      {...props}
                      municipalitySelectionHandler={
                        this.handleMunicipalitySelection
                      }
                    />
                  </React.Fragment>
                )}
              />
              <Route
                path='/abstimmungsfragen'
                render={props => (
                  <React.Fragment>
                    <ScrollToTopOnMount />
                    <Questionnaire
                      municipalityId={this.state.municipalityId}
                      handleVotePreferences={this.handleVotePreference}
                      {...props}
                    />
                  </React.Fragment>
                )}
              />
              <Route
                render={props => (
                  <React.Fragment>
                    <ScrollToTopOnMount />
                    <Article
                      votePreferences={this.state.votePreference}
                      setLoading={this.setLoading}
                      unsetLoading={this.unsetLoading}
                      articleId={ARTICLE_ID}
                      {...props}
                    />
                  </React.Fragment>
                )}
                path={'/artikel/fuer/:municipalityId'}
              />
            </Switch>
          </div>
        </main>

        <Methodology />

        <Footer
          articleId={ARTICLE_ID}
          publicationDate={this.state.publicationDate}
        />
      </div>
    )
  }
}

export default hot(module)(withRouter(AppComponent))



// WEBPACK FOOTER //
// ./src/components/main/index.js